import { Zone } from 'src/features/zone/utils/types';


enum DAY_OF_WEEK {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday',
}

interface WorkingHours {
    id: string;
    all_day: boolean;
    start_time: string | null;
    end_time: string | null;
    created_at: string;
    modified_at: string;
    day_of_week: DAY_OF_WEEK;
    zone: {
        id: string;
        translations: Zone['translations'];
    };
}

export {
    DAY_OF_WEEK,
};
export type {
    WorkingHours,
};